import { Option } from '../components/common/Dropdown/Dropdown';
import { GetElsLookupsState } from '../redux/reducers/getLookups/getElsLookupsReducer';
import i18n from '../i18n';

export const bathOptions: Option[] = [
  { value: "", text: "" },
  { value: 1, text: "1" },
  { value: 1.5, text: "1.5" },
  { value: 2, text: "2" },
  { value: 2.5, text: "2.5" },
  { value: 3, text: "3" },
  { value: 3.5, text: "3.5" },
  { value: 4, text: "4" },
  { value: 4.5, text: "4.5" },
  { value: 5, text: "5" }
]

export const convertLookupsToDropdownOptions = (
  lookupState: GetElsLookupsState,
  dropdownKey: string,
  valueKey: string,
  textKey: string,
  textKeyFr: string,
  firstEmpty = true
): Option[] => {
  const lookups = lookupState.dropdowns?.[dropdownKey];

  if (!Array.isArray(lookups)) {
    return firstEmpty ? [{ value: "", text: "" }] : [];
  }

  const options: Option[] = lookups.map((lookup) => ({
    value: String(lookup[valueKey] ?? ""),
    text: i18n.language === "fr" ? String(lookup[textKeyFr] ?? "") : String(lookup[textKey] ?? ""),
    disabled: lookup.disabled
  }));

  return firstEmpty ? [{ value: "", text: "" }, ...options] : options;
}
